var _defs, _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerminalAndroid = function SvgTerminalAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10.83 19.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.85px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.43,
    y: 0.43,
    width: 9.98,
    height: 19.03,
    rx: 1.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,8.24l.66-1.15A.13.13,0,1,0,12.38,7l-.67,1.17a4.14,4.14,0,0,0-3.42,0L7.62,7a.14.14,0,0,0-.18,0,.13.13,0,0,0-.05.19l.66,1.15a3.94,3.94,0,0,0-2,3.12h8A3.94,3.94,0,0,0,12,8.24Zm-3.78,2a.34.34,0,1,1,.33-.33A.34.34,0,0,1,8.17,10.24Zm3.66,0a.34.34,0,0,1,0-.67.34.34,0,1,1,0,.67Z",
    transform: "translate(-4.59 -0.07)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerminalAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terminal-android.80ef66af.svg";
export { ForwardRef as ReactComponent };